import { useState } from "react";
import { UnitCategoryRead } from "@types";

export function useManageUnitCategory() {
  const [selectedUnitCategory, setSelectedUnitCategory] =
    useState<UnitCategoryRead | null>(null);
  const [isSideBarOpen, setIsSideBarOpen] = useState<boolean>(false);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [unitCategoryToDeleteId, setUnitCategoryToDeleteId] =
    useState<string>("");

  const toggleSideBar = () => {
    setSelectedUnitCategory(null);
    setIsSideBarOpen((prev) => !prev);
  };

  const selectUnitCategoryToEdit = (Size: UnitCategoryRead) => {
    setIsSideBarOpen(true);

    setSelectedUnitCategory(Size);
  };

  const handleCloseDetailsModal = () => {
    setIsDetailsModalOpen(false);
    setSelectedUnitCategory(null);
  };

  const handleRowClick = (rowData: { data: UnitCategoryRead }) => {
    setSelectedUnitCategory(rowData.data);
    setIsDetailsModalOpen(true);
  };

  const handlePressDeleteButton = (id: string) => {
    setUnitCategoryToDeleteId(id);
  };

  const handleCloseDeleteDialog = () => {
    setUnitCategoryToDeleteId("");
  };

  return {
    unitCategoryToDeleteId,
    selectedUnitCategory,
    isSideBarOpen,
    isDetailsModalOpen,
    setSelectedUnitCategory,
    toggleSideBar,
    selectUnitCategoryToEdit,
    handleRowClick,
    handleCloseDetailsModal,
    handlePressDeleteButton,
    handleCloseDeleteDialog,
  };
}
